import React from 'react';
import "./AllChats.css";

export default function AllWSChats() {
  return (
    <div className='all_chats'>
      <div className='top_box'>Top Box</div>
      <div className='bottom_box'>
        <input type='text' className='input_box' placeholder='Type here...' />
        <button className='submit_button'>Submit</button>
      </div>
    </div>
  );
}
